enum ErrorCodes {
	//In future: Merge with ErrorCodes from front-applet and add to the lib
	UNEXPECTED_EXCEPTION = 'UNEXPECTED_EXCEPTION',
	FILE_IS_ALREADY_LOADING = '40105',
	FILE_ALREADY_EXISTS = '40106',
	FILE_NOT_FOUND = '49901',
	BROWSER_LINK_IS_NOT_STRING = '40301',
	BROWSER_OPEN_LINK_ERROR = '50301',
	COMMAND_TYPE_IS_NOT_STRING = '40403',
	FILE_SYSTEM_LIST_STORAGE_UNITS_ERROR = '50501',
	FILE_SYSTEM_LIST_FILES_ERROR = '50502',
	FILE_SYSTEM_FILE_EXISTS_ERROR = '50503',
	FILE_SYSTEM_GET_FILE_ERROR = '50504',
	FILE_SYSTEM_WRITE_FILE_ERROR = '50505',
	FILE_SYSTEM_COPY_FILE_ERROR = '50506',
	FILE_SYSTEM_MOVE_FILE_ERROR = '50507',
	FILE_SYSTEM_DELETE_FILE_ERROR = '50508',
	FILE_SYSTEM_DOWNLOAD_FILE_ERROR = '50509',
	FILE_SYSTEM_EXTRACT_FILE_ERROR = '50510',
	FILE_SYSTEM_GET_CHECKSUM_ERROR = '50511',
	FILE_SYSTEM_CREATE_DIR_ERROR = '50512',
	FILE_SYSTEM_IS_DIR_ERROR = '50513',
	FILE_SYSTEM_READ_FILE_ERROR = '50514',
	FILE_SYSTEM_LINK_ERROR = '50515',
	FILE_SYSTEM_LINK_NOT_SUPPORTED = '50516',
	FILE_SYSTEM_APPEND_FILE_ERROR = '50517',
	FILE_SYSTEM_CREATE_ARCHIVE_FILE_ERROR = '50518',
	FILE_SYSTEM_WIPEOUT_ERROR = '50519',
	HARDWARE_SET_COLOR_ERROR = '50601',
	HARDWARE_OPEN_SERIAL_PORT_ERROR = '50602',
	HARDWARE_CLOSE_SERIAL_PORT_ERROR = '50603',
	HARDWARE_WRITE_TO_SERIAL_PORT_ERROR = '50604',
	HARDWARE_GET_BARCODE_SCANNER_VERSION_ERROR = '50605',
	HARDWARE_START_OF_UNKNOWN_BARCODE_SCANNER = '50606',
	HARDWARE_START_OF_BUSY_BARCODE_SCANNER = '50607',
	HARDWARE_START_OF_BARCODE_SCANNER_ERROR = '50608',
	HARDWARE_DEFAULT_DEVICE_NOT_FOUND = '50609',
	HARDWARE_STOP_OF_IDLE_BARCODE_SCANNER = '50611',
	HARDWARE_STOP_OF_BARCODE_SCANNER_ERROR = '50612',
	OFFLINE_CACHE_LIST_FILES_ERROR = '50901',
	OFFLINE_CACHE_SAVE_FILE_GET_FILE_ERROR = '50902',
	OFFLINE_CACHE_GET_FILE_ERROR = '50903',
	NATIVE_CACHE_GET_CONTENT_ERROR = '51001',
	NATIVE_CACHE_SAVE_CONTENT_ERROR = '51002',
	NATIVE_CACHE_DELETE_CONTENT_ERROR = '51003',
	NATIVE_CACHE_ALREADY_SAVING_CONTENT = '41001',
	SYNCHRONIZER_CONNECT_ERROR = '51101',
	SYNCHRONIZER_CLOSE_ERROR = '51102',
	SYNCHRONIZER_JOIN_GROUP_ERROR = '51103',
	SYNCHRONIZER_WAIT_ERROR = '51104',
	SYNCHRONIZER_BROADCAST_VALUE_ERROR = '51105',
	SYNCHRONIZER_LEAVE_GROUP_ERROR = '51106',
	SYNCHRONIZER_CANCEL_WAIT_ERROR = '51107',
	SYNCHRONIZER_IS_MASTER_ERROR = '51108',
	STREAM_STOP_ERROR = '51301',
	STREAM_PREPARE_ERROR = '51302',
	STREAM_GET_TRACKS_ERROR = '51303',
	STREAM_SELECT_TRACK = '51304',
	STREAM_RESET_TRACK = '51305',
	STREAM_PAUSE_ERROR = '51306',
	STREAM_RESUME_ERROR = '51307',
	STREAM_PLAY_ERROR = '51308',
	VIDEO_PLAY_ERROR = '51501',
	VIDEO_PREPARE_ERROR = '51502',
	VIDEO_STOP_ERROR = '51503',
	VIDEO_PAUSE_ERROR = '51504',
	VIDEO_RESUME_ERROR = '51505',
	DISPLAY_CAPABILITY_INVALID = '41601',
	SECURITY_PIN_CODE_INVALID = '41701',
	SECURITY_PIN_CODE_0000 = '41702',
	SECURITY_PIN_CODE_NOT_SET_YET = '41703',
}

export default ErrorCodes;
